import AboutTemplate from "../../components/about/AboutTemplate";
import Page from "../Page";
import { Grid, Typography, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const Features = () => {
  return (
    <Page className="about-page features-page" pageKey="features">
      <AboutTemplate>
        <Typography variant="h1">Features</Typography>
        <Typography variant="body1">
          Here you can find descriptions of the various features you will find
          in Mindstack.
        </Typography>
        <Typography variant="body1">
          Select a feature to learn more about it.
        </Typography>
        <Grid container />
        <Grid item xs={12} sx={{ mb: 2 }}>
          <Link component={RouterLink} to="/about/features/tasks">
            Tasks
          </Link>
        </Grid>
        <Grid item xs={12} sx={{ mb: 2 }}>
          <Link component={RouterLink} to="/about/features/mindset">
            Mindset
          </Link>
        </Grid>
        <Grid item xs={12} sx={{ mb: 2 }}>
          <Link component={RouterLink} to="/about/features/task-sorting">
            Task Sorting
          </Link>
        </Grid>
        <Grid item xs={12} sx={{ mb: 2 }}>
          <Link component={RouterLink} to="/about/features/task-search">
            Task Search
          </Link>
        </Grid>
        <Grid item xs={12} sx={{ mb: 2 }}>
          <Link component={RouterLink} to="/about/features/task-filtering">
            Task Filtering
          </Link>
        </Grid>
        <Grid item xs={12} sx={{ mb: 2 }}>
          <Link component={RouterLink} to="/about/features/day-planner">
            Day Planner
          </Link>
        </Grid>
        <Grid item xs={12} sx={{ mb: 2 }}>
          <Link component={RouterLink} to="/about/features/activities">
            Activities
          </Link>
        </Grid>
      </AboutTemplate>
    </Page>
  );
};

export default Features;
